<template>
    <div class="orders-container" @touchstart="handleTouchStart" @touchend="handleTouchEnd">
      <FloatingHeader
        title="Meus Pedidos"
        sbtitle="Gerencie seus tickets"
        :showHeader="true"
        :routeToBack="isFullApp ? '/' : 'event'"
        :hideArrowBack="isFullApp ? false : true"
        :hideSearch="true"
        :goBackOrHome="isFullApp ? true : false"
      ></FloatingHeader>
      <!-- hideArrowBack true: solucao paliativa para a demanda Sodexo, para que alunos nao tenham acesso ao cardapio dos funcionarios -->

      <div class="header" ref="orderList">
        <h2 v-for="(item, key) in header" :key="key" v-text="item.label" :class="{active: item.active}" @click="activateTab(item)"></h2>
      </div>

      <OrderListComp
        :source="header.find(h => h.active)?.value"
        @status-changed="handleStatusChanged"
      ></OrderListComp>
    </div>
</template>

<script>
import FloatingHeader from '@/components/FloatingHeader.vue'
import OrderListComp from '@/components/OrderListComp.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'OrdersView',
  components: {
    FloatingHeader,
    OrderListComp
  },
  data () {
    return {
      header: [
        { label: 'Disponíveis', value: 'available', active: true },
        { label: 'Utilizados', value: 'unavailable' },
        { label: 'Processando', value: 'pending' }
      ],
      touchStartX: 0,
      touchStartY: 0,
      touchEndX: 0,
      touchEndY: 0,
      awaitingNewOrder: false
    }
  },
  computed: {
    ...mapGetters(['getTickets', 'isFullApp'])
  },
  watch: {
    getTickets: {
      handler () {
        this.syncNewOrderTab()
      },
      deep: true
    }
  },
  mounted () {
    const isNewOrder = this.$route.query?.newOrder === 'true'

    if (isNewOrder) {
      this.awaitingNewOrder = true
      this.activateTab(this.header.find(h => h.value === 'pending'))
      this.$router.replace({ query: {} })
      this.$nextTick(() => this.syncNewOrderTab())
    } else {
      const sf = this
      setTimeout(() => {
        if (sf.getTickets?.pending?.length) {
          sf.activateTab(sf.header.find(h => h.value === 'pending'))
        }
      }, 2000)
    }
  },
  methods: {
    activateTab: function (item) {
      if (!item) return
      this.header.forEach(h => { h.active = false })
      item.active = true
    },
    getTicketCount: function (status) {
      return this.getTickets?.[status]?.length || 0
    },
    syncNewOrderTab: function () {
      if (!this.awaitingNewOrder) return

      const hasPendingTickets = this.getTicketCount('pending') > 0
      const hasAvailableTickets = this.getTicketCount('available') > 0

      if (hasPendingTickets) {
        this.activateTab(this.header.find(h => h.value === 'pending'))
        return
      }

      if (hasAvailableTickets) {
        this.awaitingNewOrder = false
        this.activateTab(this.header.find(h => h.value === 'available'))
      }
    },
    handleStatusChanged (status) {
      this.awaitingNewOrder = false
      const targetTab = this.header.find(h => h.value === status)
      if (targetTab) {
        this.activateTab(targetTab)
      }
    },

    handleTouchStart (event) {
      this.touchStartX = event.changedTouches[0].screenX
      this.touchStartY = event.changedTouches[0].screenY
      this.touchEndX = 0
      this.touchEndY = 0
    },
    handleTouchEnd (event) {
      this.touchEndX = event.changedTouches[0].screenX
      this.touchEndY = event.changedTouches[0].screenY
      const deltaX = this.touchEndX - this.touchStartX
      const deltaY = this.touchEndY - this.touchStartY

      if (this.touchEndX && Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 120) {
        const nodeList = Array.from(this.$refs?.orderList?.childNodes || {}).filter(node => node.nodeType === 1)
        const activeElement = nodeList.find(i => i.classList.contains('active'))
        const curIndex = nodeList.indexOf(activeElement)
        let nextIndex

        if (deltaX > 0) {
          nextIndex = curIndex - 1
          if (nextIndex < 0) nextIndex = 0
        } else {
          nextIndex = curIndex + 1
          if (nextIndex >= this.header.length) nextIndex = this.header.length - 1
        }
        this.activateTab(this.header[nextIndex])
      }
    }
  }
}
</script>

<style lang="less" scoped>
.orders-container {
  padding: 80px 20px 120px 20px;
  min-height: calc(var(--real-vh) - 280px);
  overflow-y: auto;
  .header {
    position: relative;
    display: table;
    margin: auto;
    h2 {
      display: inline-block;
      margin-right: 20px;
      font-size: 16px;
      transition: all .2s linear;
      cursor: pointer;
      &.active {
        color: var(--primaryColor);
        border-bottom: solid 2px var(--primaryColor);
      }
    }
  }

  :deep(.new-ticket-highlight) {
    transition: all 0.5s ease-in-out;
    background-color: #e6f7ff;
    border-radius: 16px;
    transform: scale(1.02);
    box-shadow: 0 0 15px rgba(0, 123, 255, 0.5);
  }
}
</style>
